// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9612c509","732":"937d194a","977":"b4b8b4ab"}[chunkId] + ".chunk.js";
};